export default "__VITE_ASSET__C9W$cKYA__"